import React, { Component } from 'react';

import AnimatedCard from './AnimatedCard';
import jobData from '../assets/data/job_data';

import about from '../assets/images/about/nick_on_computer.jpg';
import pro from '../assets/images/about/nick_fancy.jpg';
import withFans from '../assets/images/about/nick_with_fans.jpg';
import uOfaLogo from '../assets/images/about/ualogored.jpg';
import hackreactor from '../assets/images/about/hrcore.jpg';
import awsLogo from '../assets/images/about/amazonws.jpg';
import handsomeLogo from '../assets/images/about/handsomeLogo.jpg';
import './About.css'

export default class Work extends Component {

  render() {
    return (
      <section id='about'>
        <div className="container">
          <h2 className=''>About Me</h2>
          <hr className='special' />
          <div className='row'>
            <img id="aboutImg" className='col s10 m6 l4 offset-s1 offset-m3 offset-l4 responsive-img' src={about} alt="About me" />
          </div>
          <div className="text-faded center-align"><em>An early start.</em></div>
          <p className='text-faded'>
            Since I was 5 years old I have been in love with computers.
            I can still remember the excitement, the colors, the sounds; everything was magic.
            As I grew up I learned how to harness some of this magic.
            As I learned new things I began to think of ways that I could use it to create things.
          </p>
          <div className='row'>
            <img id="aboutImg" className='col s10 m6 l4 offset-s1 offset-m3 offset-l4 responsive-img' src={pro} alt="About me" />
          </div>
          <div className="text-faded center-align"><em>My mission is to build technologies that make the world a better place.</em></div>
          <p className='text-faded'>
            I have been a professional Software Developer for over 6 years.
            I became fascinated with programming while taking a Java Programming course with the MIS department.
            I enjoyed this course so much that I not only decided to begin a Computer Science Minor in my Junior year, but I also became a TA for the MIS department's Java 101 course.
            I graduated from the University Of Arizona’s Management Information Systems program in May 2013 and went on to attend a fully-immersive programming boot-camp called MakerSquare (now Hack Reactor).
            At the bootcamp, I learned about how to actually build fully-funcitoning web applications using Ruby on Rails, and also learned techniques for how to stay on top of things in a world where there are new things to learn every day.
          </p>
          <div className='row'>
            <img id="aboutImg" className='col s10 m6 l4 offset-s1 offset-m3 offset-l4 responsive-img' src={withFans} alt="About me" />
          </div>
          <div className="text-faded center-align"><em>Playing guitar for some adoring fans.</em></div>
          <p className='text-faded'>      
            When I am not coding I love to play songs on my guitar.
            I am currently learning music theory and slowly learning how to sing.
            You can usually catch me playing some Led Zeppelin, Sublime or <span title="They'll never be the same without John Frusciante">Red Hot Chili Peppers.</span>
          </p>

          <h4 className=''>Background</h4>
          <hr className=' sub special' />
          <div className="animated-grid">
            <AnimatedCard
              key={"UofA"}
              name={"University of Arizona"}
              description={"At The University of Arizona's Eller College of Management I earned my bachelor's degree in Management Information Systems and learned Object Oriented Programming in Java, Javascript basics, and low level programming in MIPS Assembly."}
              img={uOfaLogo}
              alt={"UofA"}
              viewLink={`http://www.arizona.edu/`}
            />
            <AnimatedCard
              key={"HackReactor"}
              name={"Hack Reactor"}
              description={"At Hack Reactor (formerly MakerSquare) I learned Ruby on Rails, Unit Testing with RSPEC, Prototypal Inheritance in Javascript, SCSS, Backbone.js, and much more."}
              img={hackreactor}
              alt={"HackReactor"}
              viewLink={`https://www.hackreactor.com/`}
            />       
            <AnimatedCard
              key={"AWS"}
              name={"Amazon Web Services"}
              description={"In May 2018, I became an Amazon Web Services Certified Solutions Architect. Specializing in building scalable, robust, and secure cloud environments using Amazon's platform."}
              img={awsLogo}
              alt={"AWS"}
              viewLink={`https://aws.amazon.com/`}
            />       
            <AnimatedCard
              key={"Handsome"}
              name={"Handsome"}
              description={"In June 2018, I began working at Handsome as their Senior Web Technologist. Architecting custom solutions for fortune 100 clients."}
              img={handsomeLogo}
              alt={"Handsome"}
              viewLink={`https://handsome.is/`}
            />       
          </div>
        </div>
      </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/About.js